/**
 * Spread color-split cards so the same product is not listed in a row.
 * Shuffle product groups, then deal one color from each product in turn.
 */
(function () {
  'use strict';

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function mixContainer(container) {
    var cards = Array.from(container.children).filter(function (el) {
      return el.hasAttribute && el.hasAttribute('data-zoony-listing-product');
    });
    if (cards.length < 3) return;

    var groups = [];
    var indexById = Object.create(null);
    cards.forEach(function (card) {
      var id = card.getAttribute('data-zoony-listing-product') || '';
      if (!Object.prototype.hasOwnProperty.call(indexById, id)) {
        indexById[id] = groups.length;
        groups.push([]);
      }
      groups[indexById[id]].push(card);
    });

    if (groups.length < 2) return;

    shuffle(groups);
    groups.forEach(shuffle);

    var max = 0;
    groups.forEach(function (g) {
      if (g.length > max) max = g.length;
    });

    var mixed = [];
    for (var i = 0; i < max; i++) {
      for (var g = 0; g < groups.length; g++) {
        if (i < groups[g].length) mixed.push(groups[g][i]);
      }
    }

    mixed.forEach(function (card) {
      container.appendChild(card);
    });
  }

  function init() {
    document.querySelectorAll('.zm-rail, [data-zc-grid], .zc-grid').forEach(mixContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
